import { ReactElement, FC } from 'react'
import Head from 'next/head'

import { ILectur } from 'constants/types/common.types'

interface ISEOArticle {
  name: string
  createdAt?: string | Date
  updatedAt?: string | Date
  Lecturs: ILectur[]
  linkTranslation?: string
}

const SEOArticle: FC<ISEOArticle> = ({
  name,
  createdAt,
  updatedAt,
  Lecturs,
  linkTranslation,
}): ReactElement => {
  const data = {
    '@context': 'https://schema.org',
    '@type': 'NewsArticle',
    headline: name,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `https://medpoint.pro/article/${linkTranslation}`,
    },
    datePublished: createdAt,
    dateModified: updatedAt,
    author: Lecturs?.map((lector: any) => {
      const { lastName, firstName, secondName, regalia, linkTranslation: lectorLink } = lector
      return {
        '@type': 'Person',
        name: `${lastName} ${firstName} ${secondName}`,
        jobTitle: regalia,
        url: `https://medpoint.pro/lecture/${lectorLink}`,
      }
    }),
    publisher: {
      name: 'Medpoint',
      url: `https://medpoint.pro/`,
    },
  }

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
      />
    </Head>
  )
}

export default SEOArticle
